module.exports = __webpack_public_path__ + "static/media/right-round.3db9cfff.svg";